import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert,
    Image, Cascader
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined} from '@ant-design/icons'
import moment from 'moment';
const {SHOW_CHILD} = Cascader;
const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Room/doview', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Room/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data,
                        status_react: data.status_react ? data.status_react : [],
                        yq_id_react: data.yq_id_react ? data.yq_id_react : [],
                        loudong_react: data.loudong_react ? data.loudong_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, {editorState: editorState, dwjj: editorState.toHTML()})
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var list = this.state.condition[name] ? this.state.condition[name].concat() : []
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            list = list.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, {[name]: list})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {[name]: fjlist})
        this.setState({
            condition: data,
        })
    }

    render() {

        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={this.mdchange.bind(this)}>新增房间</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="所在位置"
                                    required={true}
                                >
                                    {/*<Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.yq_id ? this.state.condition.yq_id : []}
                                        onChange={this.onSelChange.bind(this, 'yq_id')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.yq_id_react)}
                                    </Select>*/}
                                    <Cascader options={this.state.loudong_react}
                                              value={this.state.condition.loudong ? this.state.condition.loudong : null}
                                              style={{width: '100%'}} onChange={this.onSelChange.bind(this, 'loudong')}
                                              placeholder="请选择"
                                              fieldNames={{label: 'name', value: 'id', children: 'child'}}
                                              showCheckedStrategy={SHOW_CHILD} />
                                </Form.Item>
                            </Col>
                            {/*<Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="楼栋"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.building ? this.state.condition.building : null}
                                           onChange={this.onChange.bind(this, 'building')}/>
                                </Form.Item>
                            </Col>*/}
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="房间号"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.number ? this.state.condition.number : null}
                                           onChange={this.onChange.bind(this, 'number')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="面积"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.area ? this.state.condition.area : null}
                                           onChange={this.onChange.bind(this, 'area')} suffix={"㎡"}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="备注"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.bz ? this.state.condition.bz : null}
                                           onChange={this.onChange.bind(this, 'bz')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="图片上传"
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                listType="picture-card"
                                                onChange={this.picChange.bind(this, 'imglist')}
                                                multiple={true}
                                            >
                                                <PlusOutlined/>
                                            </Upload>
                                            <Image.PreviewGroup
                                                preview={{
                                                    onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                                                }}
                                            >
                                                <Space wrap>
                                                    {this.state.condition.imglist ? this.state.condition.imglist.map((item, index) =>
                                                        <div className='picItem'>
                                                            <Image
                                                                width={100}
                                                                height={100}
                                                                src={item.url}
                                                            />
                                                            <DeleteOutlined className="hongse"
                                                                            onClick={this.delpic.bind(this, index, 'imglist')}/>
                                                        </div>
                                                    ) : null}

                                                </Space>
                                            </Image.PreviewGroup>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="视频上传"
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'videolist')}
                                                multiple={true}
                                                data={{
                                                    pc: 1
                                                }}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap>
                                                {this.state.condition.videolist ? this.state.condition.videolist.map((item, index) =>
                                                    <div>
                                                        <a href={item.url} target="_blank">{item.name} </a>
                                                        <DeleteOutlined className="hongse"
                                                                        onClick={this.delpic.bind(this, index, 'videolist')}/>
                                                    </div>) : null}

                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="状态"
                                    required={true}
                                >
                                    <Radio.Group onChange={this.onChange.bind(this, 'status')}
                                                 value={this.state.condition.status ? this.state.condition.status : null}>
                                        {this.arrradio(this.state.status_react)}
                                    </Radio.Group>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item

                                >
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
